import { useState, useEffect } from "react";

import Loading from "../Loading";

export default function LoadingStatistics() {
  const [loadingMessage, setLoadingMessage] = useState(
    "Carregando dados do sistema..."
  );

  useEffect(() => {
    setTimeout(() => {
      setLoadingMessage("Estamos procurando suas estatísticas...");
    }, 10000);

    setTimeout(() => {
      setLoadingMessage("Aguarde um instante...");
    }, 20000);

    setTimeout(() => {
      setLoadingMessage("Finalizando os últimos ajustes...");
    }, 30000);

    setTimeout(() => {
      setLoadingMessage("Está demorando mais do que o esperado...");
    }, 60000);
  }, []);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center w-100 p-5">
      <Loading color="info" />
      <span className="text-muted">{loadingMessage}</span>
    </div>
  );
}
